import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { CasesState } from '../../states/cases.state';
import { AddMessageCommand } from './add-message.command';
import { AddMessageResult } from './add-message.result';

/**
 * Add message use case.
 * Adds a new message to a case.
 */
@Injectable({ providedIn: 'root' })
export class AddMessageUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _state = inject(CasesState);

  public execute(command: AddMessageCommand): Observable<AddMessageResult> {
    this._state.setAddingMessage(true);
    this._state.setErrorMessages(null);

    return this._repository.addMessage(command.caseId, command.messageType, command.body, command.attachments).pipe(
      tap(() => {
        this._state.setAddingMessage(false);
      }),
      map((response) => ({ messageId: response.id })),
      catchError((error) => {
        this._state.setErrorMessages(error.message || 'Failed to add message');
        this._state.setAddingMessage(false);
        return throwError(() => error);
      })
    );
  }
}
